module.exports = __webpack_public_path__ + "img/empty-2.17783204.svg";